import { defineMessages } from "react-intl";

export default defineMessages({
    logout: {
        id: "Logout",
        defaultMessage: "Logout",
        description: "Logout button",
    },
});